const online_learing = `In today's world, students have different options for how they learn. 
Some students study from home using the computer, while others go to school like they always have. 
Studying from home gives you the freedom to choose when and where you want to study. 
You can find many interesting things to read and watch on the computer. 
However, it can be difficult to stay focused without a teacher nearby to help you, and you might miss talking to your friends in person.
On the other hand, going to school means you get to talk to your teachers and friends face-to-face. 
You can learn and play together, which is a lot of fun. 
But going to school every day can be tiring, and sometimes it's hard to get there, especially if you live far away.
Each way of learning has its own good and not-so-good points. 
Some people might prefer studying from home, while others enjoy going to school. 
It's important to find what works best for you and helps you keep learning and growing every day. 
It's great that there are different ways to learn, so everyone can find what's best for them.`;

export default online_learing;